import moment from "moment/moment";
import { sto } from "../Context/InshData";
import { CostType } from "./currencySalesProfit-services";

export const selectTypes = [
  { id: 1, name: "Stocks", label: "stock" },
  { id: 2, name: "Customers", label: "customer" },
  { id: 3, name: "Currencies", label: "item" },
  { id: 4, name: "Month", label: "months" },
  { id: 5, name: "Day", label: "days" },
  { id: 6, name: "salesmen", label: "salesman" },
  { id: 7, name: "Users", label: "user" },
  { id: 8, name: "Group", label: "group" },
  // Legacy Arabic display labels were replaced by translation keys above.
];

export const selectDateOrTime = [
  { id: 1, name: "false", label: "by-date-only" },
  { id: 2, name: "true", label: "by-date-time" },
];

export const invSearchOptions = [
  { id: 1, name: "false", label: "by-date-only" },
  { id: 2, name: "true", label: "by-date-time" },
  { id: 4, name: "false", label: "zatca-authority" },
];

export const selectDateOrTimeCar = [
  { id: 1, name: "false", label: "by-date-only" },
  { id: 2, name: "true", label: "by-date-time" },
  { id: 3, name: "false", label: "car-maintenance" },
];
export const invSearchOptionsCar = [
  { id: 1, name: "false", label: "by-date-only" },
  { id: 2, name: "true", label: "by-date-time" },
  { id: 3, name: "false", label: "car-maintenance" },
  { id: 4, name: "false", label: "zatca-authority" },
];
export const selectVatTypes = [
  { id: 0, name: "0", label: "all_items" },
  { id: 1, name: "1", label: "taxable_items" },
  { id: 2, name: "2", label: "non_taxable_items" },
];
export const selectTransferType = [
  { id: 0, label: "transfer-only" },
  { id: 1, label: "transfer-and-auto-receive" },
];


export const SAdefaultValues = {
  selectType: selectTypes[0],
  dateFrom: moment(new Date()).format('YYYY-MM-DD'),
  timeFrom: moment(new Date()).format('HH:mm'),
  dateTo: moment(new Date()).format('YYYY-MM-DD'),
  timeTo: moment(new Date()).format('HH:mm'),
  selectTime:selectDateOrTime[0],
  safe: { id: -1, name: "all" },
  cust: { id: -1, name: "all" },
  user: { id: -1, name: "all" },
  stock: { id: -1, name: "all" },
  sales_man: { id: -1, name: "all" },
  group: { id: -1, name: "all" },
  branch: { id: -1, name: "all" },
  chk_withvat: false,
  type_cost: 1,
};
export const ValueItemsSearch = {
  tax_group: { id: -1, name: "all" },
  group: { id: -1, name: "all" },
  branch: { id: -1, name: "all" },
  unit: { id: -1, name: "all" },
  type: { id: -1, name: "all" },
};


export const salesmanCommTypes = [
  { id: 0, name: "commission-from-invoice-total" },
  { id: 1, name: "commission-from-item-quantity" },
];

export const invoiceTypes = [
  { id: -1, name: "all" },
  { id: 1, name: "deferred" },
  { id: 2, name: "cash" },

];

export const salesmanrpt = {
  dateFrom: moment(new Date()).format('YYYY-MM-DD'),
  timeFrom: moment(new Date()).format('HH:mm'),
  dateTo: moment(new Date()).format('YYYY-MM-DD'),
  timeTo: moment(new Date()).format('HH:mm'),
  selectTime:selectDateOrTime[0],
  salesMan: { id: -1, name: "all" },
  branch: sto.branchi,
  CommType: salesmanCommTypes[0],
  type_Cost: CostType[0],
  CommWithVat: false,
  CommWithProfit: false,
};
